import React from 'react';
import { Alert, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class TimeOffRequestStatusBar extends React.Component {
    render() {
        const { timeOffRequest, timesheetStatuses, onRecallRequested } =
            this.props;

        const ignore = Boolean(
            timeOffRequest.id == 0 || timeOffRequest.timesheetStatusId.New
        );

        if (ignore) {
            return null;
        }

        const timesheetStatus = timesheetStatuses.find(
            (ts) => ts.value == timeOffRequest.timesheetStatusId
        );

        return (
            <Alert fade={false} className="d-flex w-100">
                <div className="my-auto">
                    This time off request is currently {timesheetStatus.label}.
                    {timeOffRequest.rejectionNotes && (
                        <div>
                            <div>Here are the rejection notes:</div>
                            <div>
                                <pre>{timeOffRequest.rejectionNotes}</pre>
                            </div>
                        </div>
                    )}
                </div>

                {timeOffRequest.timesheetStatusId ==
                    TimesheetStatus.Submitted &&
                    timeOffRequest.createdByCurrentUser && (
                        <div className="ml-auto">
                            <Button
                                type="button"
                                onClick={onRecallRequested}
                                color="warning"
                            >
                                <FontAwesomeIcon
                                    icon={faUndo}
                                    className="mr-1"
                                />
                                Recall For Edit
                            </Button>
                        </div>
                    )}
            </Alert>
        );
    }
}
